import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from '../../../environments/environment';

import { AuthService, AntEnvService, AbsAuthService, HelperService, DataService } from '../../_services';
import { DataServiceProvider } from 'src/app/_providers';
import { FcmService } from 'src/app/_services/fcm.svc';
//import { DataServiceProvider } from '../../_providers/data.service.provider';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers:[{provide: AbsAuthService, useClass: AuthService}]
})
export class LoginComponent implements OnInit {

  pageData = {
    email: '', password: '', isSubmitting: false
  }
  constructor(
    private router: Router,
    private http: HttpClient,
    private firebaseAuth: AngularFireAuth,
    private svcAntEnv: AntEnvService,
    private svcAuth: AbsAuthService,
    private svcHelper: HelperService,
    public svcData: DataService,
    public svcFcm: FcmService //specific user
    //private svcAuthAbs: AbsAuthService,
    //private pvdrDataSvc: DataServicepr
  ) { 
    this.svcAuth = DataServiceProvider.useFactory(this.firebaseAuth, this.http, this.svcAntEnv);
  }

  ngOnInit() {
  }
  onSubmit(){
    this.pageData.isSubmitting = false;
    if (this.pageData.email.length < 1) {
      this.showAlert('Email should not be empty!');
      return;
    }
    if (this.pageData.password.length < 1) {
      this.showAlert('Password should not be empty!');
      return;
    }
    this.pageData.isSubmitting = true;

    var _email = this.svcHelper.aesEncrypt(this.pageData.email);
    var _password = this.svcHelper.aesEncrypt(this.pageData.password);

    if(environment.apiType == 'FB'){
      this.svcAuth.login(this.pageData.email, this.pageData.password).then(res1 => {
        if(res1.data.userId!=null){
          this.svcData.usageAdd('{"userId":"'+res1.data.userId+'","code":"LOGIN-OK-FB","actionCode":"LOGIN-FB"}').subscribe();
        }
        this.router.navigate(['/home']);
      }).catch(err => {
        this.pageData.isSubmitting = false;
        this.showAlert(err.message);
        this.svcData.usageAdd('{"userId":" ","code":"LOGIN-FAILED-FB","actionCode":"LOGIN-FB","remark":"'+this.pageData.email+'"}').subscribe();
      });
    }
    else if(environment.apiType == 'API'){
      //console.log(_password);
      this.svcAuth.login(_email, _password).subscribe(res=>{
        //console.log(res.data);
        if(res.data.userId!=null){
          this.svcFcm.requestToken(res.data.userId);//specific user
          this.svcData.usageAdd('{"userId":"'+res.data.userId+'","code":"LOGIN-OK-API","actionCode":"LOGIN-API"}').subscribe();
          this.svcData.sessionAdd('{"userId":"'+res.data.userId+'","fullName":"'+res.data.token+'","status":'+1+'}').subscribe();
        }
        this.pageData.isSubmitting = false;
        if(res.status != 'OK'){
          this.showAlert(res.message);
          this.svcData.usageAdd('{"userId":" ","code":"LOGIN-FAILED-API","actionCode":"LOGIN-API","remark":"'+this.pageData.email+'"}').subscribe();
          return;
        }
  
        var _oUser = res.data;
        //console.log(_oUser);
        this.svcAuth.setCurrentUser(_oUser);
        this.router.navigate(['/dashboard']);
      });      
    }
  }
  forgotPasswordClick(){
    this.showAlert('Sorry! Forgot Password function is still under development.');
  }
  showAlert(msg){
    M.toast({html: msg});
  }
}
